import 'babel-polyfill';
import qs from 'qs';
import { transformErrorObject } from '../services/transforms/ErrorObjectTransform';
import { formatMessage } from '../utils/Intl/IntlUtils';
import ServerAPIErrorCodes from '../server/ServerAPIErrorCodes';
import { get } from '../utils/fetch';
import cookie from 'cookie';
import { isAndroidPhone, isAndroidTablet } from '../utils/BrowserUtils';
import '../components/AppContainer/webfonts/css/dossier.css';
import './styles.scss';
import '../components/popup/MessageBoxContainer/styles.scss';
import { isUndefined, isBoolean, get as lodashGet } from 'lodash';

const STANDARD = 1;
const GUEST = 8;
const LDAP = 16;

const TRUSTED = 64;   
const KERBEROS = 128;
const SAML = 1048576;
const OIDC = 4194304;
const userNameRequired = formatMessage(124, 'User name required');
const TABLEAU = 'Tableau';

const _htmlDecodeRep = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&nbsp;': ' ',
    '<br/>': '\n',  
    '&nbsp;&nbsp;&nbsp;&nbsp;': '\r',  
    '&#39;': '\'',
    '&#34;': '"'
};

const multiReplace = function multiReplace(s, hash, skip) {
    let k;
    skip = skip || [];
    if (!s) {
        return '';
    }
    let keys = [];
    for (k in hash) {

        if (skip.indexOf(k) === -1) {
            keys.push(k.k || k); 
        }
    }

    return s.replace(new RegExp(keys.join('|'), 'g'), function ($0) {
        let v = hash[$0];
        return v.v || v;           
    });
};

const decodeHtml = function decodeHtml(v) {
    return multiReplace(v, _htmlDecodeRep);
};




function onAutoFill(elem, callback) {
    elem.addEventListener('animationstart', onAnimationStart);

    function onAnimationStart(event) {
        
        
        
        if (event.animationName === 'onautofillstart') {
            
            callback();
        }
    }
}

class MstrAuth {
    constructor() {
        this.elUsername = document.getElementById('username');
        this.elPassword = document.getElementById('password');
        this.elOldPassword = document.getElementById('oldPassword');
        this.elNewPassword = document.getElementById('newPassword');
        this.elConfirmNewPassword = document.getElementById('confirmNewPassword');
        this.elPlaceholderUsername = document.getElementById('placeholderUsername');
        this.elPlaceholderPassword = document.getElementById('placeholderPassword');
        this.elPlaceholderOldPassword = document.getElementById('placeholderOldPassword');
        this.elPlaceholderNewPassword = document.getElementById('placeholderNewPassword');
        this.elPlaceholderConfirmNewPassword = document.getElementById('placeholderConfirmNewPassword');
        this.elLoginModeRadio = document.getElementById('loginModeRadio');
        this.elLoginButton = document.getElementById('loginButton');
        this.elChangePwdButton = document.getElementById('changePwdButton');
        this.elMessageBoxText = document.getElementsByClassName('mstrd-MessageBox-text')[0];
        this.elMessageBoxOk = document.getElementById('ActionLinkContainer');
        this.elLoginView = document.querySelector('.credsLoginView');
        this.elStandardLogin = document.getElementById('StandardModeLabel');
        this.elLdapLogin = document.getElementById('LDAPModeLabel');
        this.elTrustedLogin = document.getElementById('TrustedModeDiv');
        this.elIntegratedLogin = document.getElementById('IntegratedModeDiv');
        this.elSamlLogin = document.getElementById('SAMLModeDiv');
        this.elOidcLogin = document.getElementById('OIDCModeDiv');
        this.elGuestLogin = document.getElementById('GuestModeDiv');
        this.elIserverConnection = document.querySelector('.iServerErrContainer');
        this.elLogoContainer = document.querySelector('.logo-container');
        this.elAdminRedirect = document.querySelector('.admin-page');
        this.elLoginRowModes = document.getElementById('login-row-modes');
        this.isSessionLoading = false;

    }
    bindingEventsLoginPage() {


        this.elUsername.onblur = () => {
            
            
            
            
            if (!this.elUsername.value.length && !this.elUsername.autofilled) {
                this.elPlaceholderUsername.className = 'placeholder';
            }
            this.renderLoginButton();
        };

        
        
        this.elUsername.oninput = () => {
            
            this.elUsername.autofilled = false;
            this.elPlaceholderUsername.className = 'placeholder active';
            this.renderLoginButton();
        };

        this.elUsername.onclick = () => {
            this.renderLoginButton();
        };

        this.elUsername.onfocus = () => {
            this.elPlaceholderUsername.className = 'placeholder active';
            this.renderLoginButton();
        };

        this.elPassword.onblur = () => {
            if (!this.elPassword.value.length) {
                this.elPlaceholderPassword.className = 'placeholder';
            }
        };

        this.elPassword.onfocus = () => {
            this.elPlaceholderPassword.className = 'placeholder active';
        };

        
        
        
        this.elPassword.oninput = () => {
            this.elPlaceholderPassword.className = 'placeholder active';
        };

        this.elOldPassword.onblur = () => {
            if (!this.elOldPassword.value.length) {
                this.elPlaceholderOldPassword.className = 'placeholder';
            }
        };

        this.elOldPassword.onfocus = () => {
            this.elPlaceholderOldPassword.className = 'placeholder active';
        };

        this.elNewPassword.onblur = () => {
            if (!this.elNewPassword.value.length) {
                this.elPlaceholderNewPassword.className = 'placeholder';
            }
        };

        this.elNewPassword.onfocus = () => {
            this.elPlaceholderNewPassword.className = 'placeholder active';
        };

        this.elConfirmNewPassword.onblur = () => {
            if (!this.elConfirmNewPassword.value.length) {
                this.elPlaceholderConfirmNewPassword.className = 'placeholder';
            }
        };

        this.elConfirmNewPassword.onfocus = () => {
            this.elPlaceholderConfirmNewPassword.className = 'placeholder active';
        };

        this.elLoginModeRadio.onclick = () => {
            this.renderLoginButton();
        };

        this.elOldPassword.onkeyup = () => {
            this.renderChangePwdButton();
        };

        this.elNewPassword.onkeyup = () => {
            this.renderChangePwdButton();
        };

        this.elConfirmNewPassword.onkeyup = () => {
            this.renderChangePwdButton();
        };

        this.elMessageBoxOk.onclick = () => {
            this.messageBoxOKhandleClick();
        };

        this.elMessageBoxOk.onkeydown = (evt) => {
            if (evt.key === 'Enter' || evt.key === ' ' || evt.key === 'Escape') {
                evt.preventDefault();
                this.messageBoxOKhandleClick();
            } else if (evt.key === 'Tab') {
                
                
                evt.preventDefault();
            }
        };

        this.elLoginRowModes.onmousedown = () => {
            this.elLoginRowModes.classList.add('mouseFocus');
        };

        document.body.onkeyup = () => {
            this.elLoginRowModes.classList.remove('mouseFocus');
        };

        this.elStandardLogin.onclick = () => {
            this.elStandardLogin.previousElementSibling.checked = true;
            this.elStandardLogin.setAttribute('aria-checked', 'true');
            this.elLdapLogin.setAttribute('aria-checked', 'false');
        };

        this.elStandardLogin.onkeydown = (evt) => {
            if (evt.key === 'Enter') {
                this.elStandardLogin.previousElementSibling.checked = true;
                this.elStandardLogin.setAttribute('aria-checked', 'true');
                this.elLdapLogin.setAttribute('aria-checked', 'false');
            }
        };

        this.elLdapLogin.onclick = () => {
            this.elLdapLogin.previousElementSibling.checked = true;
            this.elLdapLogin.setAttribute('aria-checked', 'true');
            this.elStandardLogin.setAttribute('aria-checked', 'false');
        };

        this.elLdapLogin.onkeydown = (evt) => {
            if (evt.key === 'Enter') {
                this.elLdapLogin.previousElementSibling.checked = true;
                this.elLdapLogin.setAttribute('aria-checked', 'true');
                this.elStandardLogin.setAttribute('aria-checked', 'false');
            }
        };

        this.elTrustedLogin.onclick = () => {
            this.iconClick(this.elTrustedLogin);
        };

        this.elTrustedLogin.onkeydown = (evt) => {
            if (evt.key === 'Enter') {
                this.iconClick(this.elTrustedLogin);
            }
        };

        this.elIntegratedLogin.onclick = () => {
            this.iconClick(this.elIntegratedLogin);
        };

        this.elIntegratedLogin.onkeydown = (evt) => {
            if (evt.key === 'Enter') {
                this.iconClick(this.elIntegratedLogin);
            }
        };

        this.elSamlLogin.onclick = () => {
            this.iconClick(this.elSamlLogin);
        };

        this.elSamlLogin.onkeydown = (evt) => {
            if (evt.key === 'Enter') {
                this.iconClick(this.elSamlLogin);
            }
        };

        this.elOidcLogin.onclick = () => {
            this.iconClick(this.elOidcLogin);
        };

        this.elOidcLogin.onkeydown = (evt) => {
            if (evt.key === 'Enter') {
                this.iconClick(this.elOidcLogin);
            }
        };

        this.elGuestLogin.onclick = () => {
            this.iconClick(this.elGuestLogin);
        };

        this.elGuestLogin.onkeydown = (evt) => {
            if (evt.key === 'Enter') {
                this.iconClick(this.elGuestLogin);
            }
        };

        this.elLoginButton.onclick = (evt) => {
            if (this.elLoginButton.style.cursor === 'not-allowed') {
                evt.preventDefault();
                evt.stopPropagation();

                
                
                
                return false;
            }
            
            this.isSessionLoading = true;
            this.renderLoginButton();

            let LDAPRadioButton = document.querySelector('#LDAP');
            let previousAuthMode = LDAPRadioButton.checked ? LDAP : STANDARD;
            document.cookie = cookie.serialize('previousAuthMode', previousAuthMode);
        };

        
        onAutoFill(this.elUsername, () => {
            
            this.elUsername.autofilled = true;
            this.elPlaceholderUsername.className = 'placeholder active';
            this.renderLoginButton();
        });

        
        onAutoFill(this.elPassword, () => {
            this.elPlaceholderPassword.className = 'placeholder active';
        });
    }

    onloadLoginPage(err, loginError, username, isChangePwd, isIServerConnected) {

        
        if (!isIServerConnected) {
            document.querySelector('.title').style.display = 'none';
            document.querySelector('.mstr-CredsLogin-auth-mode').style.display = 'none';
            document.querySelector('.mstr-CredsLogin-form-section').style.display = 'none';
            this.elLogoContainer.style.display = 'none';
            this.elIserverConnection.style.display = (navigator.userAgent.includes(TABLEAU)) ? 'flex' : 'block';
            this.localizeIserverError();
            this.elLoginView.style.display = 'block';
            this.renderMobileBanner();
            return;
        }

        this.getAuthModes().then((response) => {
            let modes = response.modes;
            let numDirectLoginModes = 0;   

            
            let singleRadioMode = false;
            let noRadioModes = true;      
            let noIconModes = true;       
            let saml = response.saml;
            let isUsher = false; 
            if (saml) {
                isUsher = saml.isUsher;
            }
            


            if (!modes || modes.length == 0) {
                window.location = window.location.origin + '/' + window.location.pathname.split('/')[1] + '/auth/ui/LoginErrorPage';
                return;
            }

            
            this.elLoginView.style.display = 'block';

            
            if (window.top === window) {
                this.elUsername.focus();
            }

            modes.forEach(authMode => {
                const authModeMap = {
                    [STANDARD]: '#StandardModeLabel',
                    [GUEST]: '#GuestModeDiv',
                    [LDAP]: '#LDAPModeLabel',
                    
                    [TRUSTED]: '#TrustedModeDiv',
                    [SAML]: '#SAMLModeDiv',
                    [OIDC]: '#OIDCModeDiv',
                    [KERBEROS]: '#IntegratedModeDiv'
                };
                if (authModeMap[authMode]) {
                    const display = [STANDARD, LDAP].indexOf(authMode) > -1 ? 'block' : 'flex';
                    document.querySelector(authModeMap[authMode]).style.display = display;
                } else {
                    return;
                }
                
                
                
                
                
                
                if (authMode === STANDARD || authMode === LDAP) {
                    singleRadioMode = !singleRadioMode;
                    noRadioModes = false;
                } else if (authMode === GUEST || authMode === TRUSTED || authMode === KERBEROS || authMode === SAML || authMode === OIDC) {
                    numDirectLoginModes++;
                    noIconModes = false;
                }
            });

            
            this.checkStandardOrLDAP(modes, singleRadioMode);

            let classNames = '';
            
            if (singleRadioMode) {
                classNames += ' singleMode';
                document.querySelector('.login-modes-row').style.display = 'none';
                
                if (noIconModes) {
                    classNames += ' standardOnly';
                }
            } else if (noRadioModes && numDirectLoginModes) { 
                document.getElementById('loginForm').style.display = 'none';
                let iconOnlyMsgElem = document.getElementById('iconOnlyMessages');
                iconOnlyMsgElem.style.display = 'block';
                if (numDirectLoginModes === 1) {
                    classNames += ' guestOnly';
                    
                } else {
                    classNames += ' iconOnly';
                    iconOnlyMsgElem.innerText = formatMessage(367, 'Choose an authentication type to log in');
                }
            }
            
            if (noIconModes) {
                document.querySelector('.icon-row-container').style.display = 'none';
                classNames += ' noIconModes';
            } else if (numDirectLoginModes <= 2) {    
                document.querySelector('.icon-row-container').style.justifyContent = 'space-around';
            }

            this.elLoginView.className = this.elLoginView.className + classNames;

            if (modes.length > numDirectLoginModes && numDirectLoginModes > 0
                && (document.querySelector('.icon-row-container').style.display !== 'none')) {
                document.querySelector('.extra-modes-label').style.display = 'block';
            }

            
            const elSamlName = document.querySelector('.saml-name');
            if (isUsher) {
                elSamlName.textContent = formatMessage(1455, 'Log in with Badge');
                document.querySelector('.icon-saml').className = 'login-icons  icon-usher';
                this.elSamlLogin.setAttribute('aria-label', formatMessage(1359, 'USHER authentication'));
            } else {
                elSamlName.textContent = formatMessage(1456, 'Log in with identity');
            }

            
            addTextAlignStyle(elSamlName);

            
            this.elLoginButton.title = formatMessage(1460, 'Log in with your username and password');
            
            this.elIntegratedLogin.title = formatMessage(1461, 'Log in with your Kerberos account');
            this.elSamlLogin.title = isUsher ? formatMessage(1462, 'Log in with your MicroStrategy Badge') : formatMessage(1463, 'Log in with your SAML Identity Provider');
            this.elGuestLogin.title = formatMessage(1464, 'Log in with the Guest account');
        }).catch(() => {
            this.elLoginView.style.display = 'block';
        });

        this.elUsername.value = decodeHtml(username);
        this.renderLoginButton();
        if (this.elUsername.value.length) {
            this.elPlaceholderUsername.className = 'placeholder active';
        } else if (this.elPassword.value.length) {
            this.elPlaceholderPassword.className = 'placeholder active';
        }
        this.setupFormLocale();
        this.localizeLoginPage();

        this.elLoginView.classList.remove('changePwd');
        document.getElementById('changePwdHeader').style.display = 'none';

        this.handleErrors(err, loginError, isChangePwd);
        this.renderMobileBanner();
    }

    localizeLoginPage() {
        document.querySelector('.title').textContent = formatMessage(387, 'MicroStrategy Library');
        document.querySelector('.username-span').textContent = formatMessage(30, 'User Name');
        document.querySelector('.password-span').textContent = formatMessage(4, 'Password');

        document.querySelector('.login-button').value = formatMessage(1457, 'Log in with credentials');
        document.querySelector('.standard-span').textContent = formatMessage(14, 'Standard');
        document.querySelector('.ldap-span').textContent = formatMessage(180, 'LDAP');
        

        document.querySelector('.trusted-name').textContent = formatMessage(1499, 'Log in'); 
        document.querySelector('.oidc-name').textContent = formatMessage(2709, 'Log in with OIDC'); 
        document.querySelector('.guest-name').textContent = formatMessage(1458, 'Log in as Guest');
        document.querySelector('.integrated-name').textContent = formatMessage(1459, 'Log in with Kerberos');

        
        addTextAlignStyle(document.querySelector('.trusted-name'));
        addTextAlignStyle(document.querySelector('.guest-name'));
        addTextAlignStyle(document.querySelector('.integrated-name'));


        document.querySelector('.ok-span').textContent = formatMessage(174, 'OK');
        document.querySelector('.oldPassword-span').textContent = formatMessage(224, 'Old Password');
        document.querySelector('.newPassword-span').textContent = formatMessage(225, 'New Password');
        document.querySelector('.confirmNewPassword-span').textContent = formatMessage(226, 'Confirm New Password');
        document.querySelector('.changePwdHeader').textContent = formatMessage(223, 'Set a new password');
        document.getElementById('changePwdButton').value = formatMessage(222, 'Done');
        this.elUsername.setAttribute('aria-label', userNameRequired);
        this.elPassword.setAttribute('aria-label', formatMessage(4, 'password'));
        this.elOldPassword.setAttribute('aria-label', formatMessage(224, 'Old Password'));
        this.elNewPassword.setAttribute('aria-label', formatMessage(225, 'New Password'));
        this.elConfirmNewPassword.setAttribute('aria-label', formatMessage(226, 'Confirm New Password'));
        document.querySelector('.changePwdHeader').setAttribute('aria-label', formatMessage(223, 'Set a new password'));
        document.getElementsByClassName('mstrd-SmartBanner-title').textContent = formatMessage(387, 'MicroStrategy Library');
        document.querySelector('.mstrd-SmartBanner-desc').textContent = formatMessage(381, 'MicroStrategy Inc.');
        document.querySelector('.mstrd-SmartBanner').ariaLabel = formatMessage(375, 'Open in app smart banner');
        document.querySelector('.mstrd-SmartBanner-close').ariaLabel = formatMessage(376, 'Close Banner');
        document.querySelector('.mstrd-SmartBanner-content').ariaLabel = formatMessage(377, 'Click or tap to download MicroStrategy Library App');
        document.getElementsByClassName('mstrd-SmartBanner-openLink')[0].textContent = formatMessage(1231, 'Download');
        document.getElementsByClassName('mstrd-SmartBanner-openLink')[1].textContent = formatMessage(1232, 'Open');
    }

    localizeIserverError() {
        document.querySelector('.iServerErr_msg').textContent = formatMessage(1193, 'The Intelligence Server is not connected. To connect, go to Library Admin page.');
        document.querySelector('.iServerErr_title').textContent = formatMessage(1205, 'Configuration Error');
        this.elAdminRedirect.value = formatMessage(1194, 'Library Admin page');
    }
    renderMessageBox({ title, desc, icon }) {
        this.renderErrorImage(icon);
        document.querySelector('.mstrd-MessageBox-titleSpan').textContent = title;
        document.querySelector('.mstrd-MessageBox-descSpan').textContent = desc;
        document.getElementById('MessageBoxContainer').style.display = (navigator.userAgent.includes(TABLEAU)) ? 'flex' : 'block';
        this.elMessageBoxOk.focus();

    }


    isNewPasswordRequired(error) {
        if (error && error.iServerErrorCode) {
            return ServerAPIErrorCodes.toHex(error.iServerErrorCode) == ServerAPIErrorCodes.AUTHEN_E_LOGIN_FAILED_NEW_PASSWORD_REQD;
        }
        return false;
    }

    renderChangePassword() {
        this.elLoginModeRadio.style.display = 'none';
        this.elLoginView.classList.add('changePwd');
        document.getElementById('loginForm').style.display = 'none';
        document.getElementById('changePwdForm').style.display = 'block';
        document.getElementById('changePwdHeader').style.display = 'block';
        document.querySelector('.icon-row-container').style.display = 'none';
        document.querySelector('.extra-modes-label').style.display = 'none';
        this.elOldPassword.focus();

        this.renderChangePwdButton();
    }

    renderLoginButton() {
        let elLoginButton = this.elLoginButton;
        
        let loginBtnDisabled = !(this.elUsername.value.trim()) && !this.elUsername.autofilled || this.isSessionLoading;

        if (loginBtnDisabled) {
            elLoginButton.style.cursor = 'not-allowed';
            elLoginButton.classList.add('disabledLogin');
            elLoginButton.setAttribute('aria-label', formatMessage(1365, 'Log in disabled'));
        } else {
            elLoginButton.style.cursor = 'auto';
            elLoginButton.classList.remove('disabledLogin');
            elLoginButton.setAttribute('aria-label', formatMessage(39, 'Log in'));
        }
        elLoginButton.style.display = 'block';
        this.elChangePwdButton.style.display = 'none';
    }

    renderChangePwdButton() {
        let elChangePwdButton = this.elChangePwdButton;
        let disabled = !(this.elOldPassword.value !== this.elNewPassword.value && this.elNewPassword.value === this.elConfirmNewPassword.value);
        elChangePwdButton.disabled = disabled;
        if (disabled) {
            elChangePwdButton.style.cursor = 'not-allowed';
            elChangePwdButton.classList.add('disabledLogin');
        } else {
            elChangePwdButton.style.cursor = 'auto';
            elChangePwdButton.classList.remove('disabledLogin');
        }
        elChangePwdButton.style.display = 'block';
        this.elLoginButton.style.display = 'none';
    }

    renderMobileBanner() {
        
        const smartBannerFeatureFlag = lodashGet(window, 'dossierConfig.features.smartBanner');
        
        const isEmbedded = this.getCustomizationValue('embed') || this.getCustomizationValue('app.embedded');
        const config = isEmbedded ? { 'feature.smartBanner': false } : null; 
        let smartBannerEnabled = this.getCustomizationValue('feature.smartBanner', config);

        
        
        if (isBoolean(smartBannerFeatureFlag)) {
            smartBannerEnabled = smartBannerFeatureFlag;
        }

        
        let ua = navigator.userAgent;
        if (smartBannerEnabled && window.localStorage.getItem('SmartBannerDismissed') !== 'true' && (ua.includes('iPad') || ua.includes('iPhone') || isAndroidTablet() || isAndroidPhone())) {
            document.getElementsByClassName('mstrd-SmartBanner')[0].style.display = 'block';
            document.getElementsByClassName('mstrd-SmartBanner-close')[0].onclick = this.closeBanner;
            document.getElementsByClassName('mstrd-SmartBanner-openLink')[1].onclick = this.openInApp;
            document.getElementsByClassName('mstrd-SmartBanner-title')[0].style.display = 'inline-block';
            let appIcon = require('../components/misc/SmartBannerCurtain/images/app-icon.png');
            document.getElementsByClassName('mstrd-SmartBanner-appIcon')[0].style.backgroundImage = `url(${appIcon})`;
            if (ua.includes('iPhone')) {
                document.getElementsByClassName('mstrd-SmartBanner-link')[0].href = 'https://itunes.apple.com/us/app/microstrategy-dossier-for/id1333261570?mt=8';
            }
            if (isAndroidTablet() || isAndroidPhone()) {
                document.getElementsByClassName('mstrd-SmartBanner-link')[0].href = 'https://play.google.com/store/apps/details?id=com.microstrategy.android.dossier';
            }
        }
    }
    
    
    
    getCustomizationValue(feature, config) {
        let url = window.loadingPageConfig.redirectURL.split('?');
        if (isUndefined(url[1])) {
            url = window.location.href.split('?');
        }
        const hasParams = url.length > 1;
        let queryFeature;
        let configFeature;
        if (hasParams) {
            queryFeature = (qs.parse(url[1], { strictNullHandling: false }) || {})[feature];
        }
        if (config) {
            configFeature = config[feature];
        }
        
        const featureByQuery = ['1', 'true'].includes(queryFeature);
        const featureByConfig = ['1', 'true'].includes(configFeature);
        const featureEnabledByCustomization = window.mstrdossier && window.mstrdossier.customization && window.mstrdossier.customization[feature];
        const featureEnabled = !isUndefined(queryFeature) ? featureByQuery : (!isUndefined(configFeature) ? featureByConfig : featureEnabledByCustomization);

        return featureEnabled;
    }


    closeBanner() {
        window.localStorage.setItem('SmartBannerDismissed', true);
        document.getElementsByClassName('mstrd-SmartBanner')[0].style.display = 'none';
    }

    openInApp() {
        let href = window.loadingPageConfig.redirectURL;
        if (!href.includes('/app')) {
            href = window.location.origin + window.loadingPageConfig.contextPath + '/app';
        }
        window.location.replace(`dossier://?url=${escape(href)}`);
    }

    setupFormLocale() {
        let locale = window.dossierConfig.locale || 'en';

        let standardLoginForm = document.getElementById('loginForm');
        standardLoginForm.elements['mdLocale'].value = locale;
        standardLoginForm.elements['whLocale'].value = locale;
        standardLoginForm.elements['displayLocale'].value = locale;
        standardLoginForm.elements['messagesLocale'].value = locale;
        standardLoginForm.elements['numberLocale'].value = locale;

        let miscLoginForm = document.getElementById('miscLoginForm');
        miscLoginForm.elements['mdLocale'].value = locale;
        miscLoginForm.elements['whLocale'].value = locale;
        miscLoginForm.elements['displayLocale'].value = locale;
        miscLoginForm.elements['messagesLocale'].value = locale;
        miscLoginForm.elements['numberLocale'].value = locale;
    }

    messageBoxOKhandleClick() {
        document.getElementById('MessageBoxContainer').style.display = 'none';
        
        this.isSessionLoading = false;
        if (this.elUsername.value.trim()) {
            if (document.getElementById('changePwdForm').style.display === 'block') {
                this.elOldPassword.focus();
            } else {
                this.elPassword.focus();
            }
        } else {
            this.elUsername.focus();
        }
    }

    getAuthModes() {
        const url = window.loadingPageConfig.contextPath + '/api/config/authModes';
        return get(url);
    }

    
    checkStandardOrLDAP(modes, singleRadioMode) {
        
        let previousLoginMode = parseInt(window.loadingPageConfig.previousLoginMode);
        let standardRadioButton = document.querySelector('#Standard');
        let LDAPRadioButton = document.querySelector('#LDAP');
        
        

        
        let cookies = cookie.parse(document.cookie);
        let previousAuthMode = cookies['previousAuthMode'];
        if (previousAuthMode) {
            previousLoginMode = parseInt(previousAuthMode);
        }

        if (singleRadioMode) {
            if (modes.includes(LDAP)) {
                LDAPRadioButton.checked = true;
            }
        } else {
            if (modes.includes(previousLoginMode)) {
                switch (previousLoginMode) {
                    case STANDARD:
                        standardRadioButton.checked = true;
                        break;
                    case LDAP:
                        LDAPRadioButton.checked = true;
                        break;
                }
            }
        }
    }

    
    iconClick(elem) {
        elem.children[0].checked = true;
        elem.parentNode.parentNode.submit();
    }

    handleErrors(err, loginError, isChangePwd) {
        if (loginError && loginError.errorCode && loginError.errorCode !== '0') {
            this.elLoginView.style.display = 'block';

            
            
            
            
            
            if (this.isNewPasswordRequired(loginError)) {
                this.renderChangePassword();
                return;
            }

            
            
            
            
            
            
            
            
            if (isChangePwd) {
                this.renderChangePassword();
            }

            
            
            
            
            let error = transformErrorObject(loginError);
            
            if (err !== null && error !== null) {
                this.renderMessageBox(error);
            }
        }
    }

    renderErrorImage(icon) {
        let img;
        switch (icon) {
            case 'server':
                img = require('../components/popup/MessageBoxContainer/images/Server Error.svg');
                break;
            case 'user':
                img = require('../components/popup/MessageBoxContainer/images/Web Configuration Error.svg');
                break;
            case 'admin':
                img = require('../components/popup/MessageBoxContainer/images/Web Admin Error.svg');
                break;
            case 'app':
            default:
                img = require('../components/popup/MessageBoxContainer/images/Web Application Error.svg');
        }
        document.querySelector('.mstrd-MessageBox-errorImg').src = img;
    }
}

function addTextAlignStyle(el) {
    const span = document.createElement('span');
    span.textContent = el.textContent;
    span.class = 'icon-name'; 
    span.cssText = 'visibility: hidden; position: aboslute; top: -1000px; padding: 0;'; 
    document.body.appendChild(span);

    let style = '';
    if (span.offsetWidth > 176) {
        style = ';text-align: left;';
    } else {
        style = ';padding-right: 42px;';
    }
    el.style.cssText += style;

    
    document.body.removeChild(span);
}

const mstrAuth = new MstrAuth();
mstrAuth.bindingEventsLoginPage();
mstrAuth.onloadLoginPage(window.loadingPageConfig.error,
    window.loadingPageConfig.loginError,
    window.loadingPageConfig.username,
    window.loadingPageConfig.isChanged,
    window.loadingPageConfig.isIServerConnected
);
